

import React from 'react';
import api from './apiConnector'

import DatePicker, { registerLocale } from "react-datepicker";
import Select from 'react-select'
import ControlledInput from './controlledInput';

import fr from 'date-fns/locale/fr';
import "react-datepicker/dist/react-datepicker.css";
import wait from './img/wait.svg';

registerLocale('fr', fr)

class SearchBar extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            users:[],
            affiliateLogins:[]
        }
    }

    componentDidMount() {
        api.post(
            {action:'list_users'},
            (res)=>{
                this.setState({users:res.users})
                if ( res.affiliateLogins ) this.setState({affiliateLogins:res.affiliateLogins})
            }
        )
    }

    makeUserOptions() {
        return [ {'value':'-','label':'Non affecté'}, ... this.state.users.map( user => ({'value':user.login,'label':user.login}) )]
    }

    getOptionsAffiliateApporteurs() {
        return this.state.affiliateLogins.map(
            login => ({ value: 'affiliate '+login, label: login })
        )
    }

    render() {
        const {operator} = this.props
        const isMoto = this.props.type == 'moto'

        return this.props.quotations ? <div className="search_bar">
                <div className="search_column">
                    <span className="left_title">Filtres</span>
                </div>
                <div className="search_column right_search_column">
                    <div className="search_entry"><label>Créé après</label><div className="date_picker"><DatePicker dateFormat="dd/MM/yyyy" isClearable showYearDropdown locale="fr" selected={this.props.startDate} onChange={this.props.app.setStartDate.bind(this.props.app)} /></div></div>
                    <div className="search_entry"><label>et/ou avant</label><div className="date_picker"><DatePicker dateFormat="dd/MM/yyyy" isClearable showYearDropdown locale="fr" selected={this.props.endDate} onChange={this.props.app.setEndDate.bind(this.props.app)} /></div></div>
                    <Select placeholder="Apporteur" isMulti options={operator ? SearchBar.optionsApporteur : this.getOptionsAffiliateApporteurs()} value={this.props.searchApporteur} onChange={this.props.app.setSearchApporteur.bind(this.props.app)}/>
                </div>
            </div> : <div className="search_bar">
            <div className="search_column">
                <span className="left_title">Filtres</span>
                <Select placeholder="Status" isMulti options={ operator ? SearchBar.optionsStatusProcess : SearchBar.optionsStatusProcessAffiliates } value={this.props.searchStatusProcess} onChange={this.props.app.setSearchStatusProcess.bind(this.props.app)}/>
                <Select placeholder="Status de traitement" isMulti options={SearchBar.optionsStatus} value={this.props.searchStatus} onChange={this.props.app.setSearchStatus.bind(this.props.app)}/>
                <div className="search_entry"><label>Mes devis uniquement <input type="checkbox" checked={this.props.searchSelf} onChange={this.props.app.setSearchSelf.bind(this.props.app)}/></label></div>
                <div className="search_entry"><label>Devis en attente <input type="checkbox" checked={this.props.searchUnvalidated} onChange={this.props.app.setSearchUnvalidated.bind(this.props.app)}/></label></div>
                {operator ? <div className="search_entry"><label>Masquer Sollyazar <input type="checkbox" checked={this.props.searchNoSolly} onChange={this.props.app.setSearchNoSolly.bind(this.props.app)}/></label></div> : <></>}
                { /*operator ? <div className="search_entry"><label>Affiliés uniquements <input type="checkbox" checked={this.props.searchAffiliateOnly} onChange={this.props.app.setSearchAffiliateOnly.bind(this.props.app)}/></label></div> : <></> */}
                <Select placeholder="Commercial" isMulti options={this.makeUserOptions()} value={this.props.searchUser.map(login=>( (login=='-')?{value:'-',label:'Non affecté'}:{value:login,label:login}))} onChange={this.props.app.setSearchUser.bind(this.props.app)}/>
                <Select placeholder="Apporteur" isMulti options={operator ? SearchBar.optionsApporteur : this.getOptionsAffiliateApporteurs()} value={this.props.searchApporteur} onChange={this.props.app.setSearchApporteur.bind(this.props.app)}/>
                {operator && isMoto && <Select placeholder="Assureur" options={SearchBar.optionsAssureurs} value={ SearchBar.optionsAssureurs.find(opt=>opt.value == this.props.searchAssureur) } onChange={this.props.app.setSearchAssureur.bind(this.props.app)}/>}
                {operator && isMoto && <Select placeholder="Origine" options={SearchBar.optionsAssureursOrigin} value={ SearchBar.optionsAssureursOrigin.find(opt=>opt.value == this.props.searchAssureurOrigin) } onChange={this.props.app.setSearchAssureurOrigin.bind(this.props.app)}/>}
                {this.props.loading ? <img src={wait} className="wait_img"/> : ''}
            </div>
            <div className="search_column right_search_column">
                <div className="barbox">
                    <label>Date de création</label>
                    <div className="search_entry"><label>du</label><div className="date_picker"><DatePicker dateFormat="dd/MM/yyyy" isClearable showYearDropdown locale="fr" selected={this.props.startDate} onChange={this.props.app.setStartDate.bind(this.props.app)} /></div></div>
                    <div className="search_entry"><label>au</label><div className="date_picker"><DatePicker dateFormat="dd/MM/yyyy" isClearable showYearDropdown locale="fr" selected={this.props.endDate} onChange={this.props.app.setEndDate.bind(this.props.app)} /></div></div>
                    <label>Dernière modification</label>
                    <div className="search_entry"><label>du</label><div className="date_picker"><DatePicker dateFormat="dd/MM/yyyy" isClearable showYearDropdown locale="fr" selected={this.props.startDateModif} onChange={this.props.app.setStartDateModif.bind(this.props.app)} /></div></div>
                    <div className="search_entry"><label>au</label><div className="date_picker"><DatePicker dateFormat="dd/MM/yyyy" isClearable showYearDropdown locale="fr" selected={this.props.endDateModif} onChange={this.props.app.setEndDateModif.bind(this.props.app)} /></div></div>
                    
                </div>
                <div className="search_entry"><label>Nom</label>
                <ControlledInput type="text" property="searchName" originProperty="filterName" container={this.props.app}
                    onSubmit={this.props.app.onFilter.bind(this.props.app)}
                    withSaveButton withClearButton
                    />
                </div>
                <div className="search_entry"><label>Téléphone</label>
                <ControlledInput type="text" property="searchTelephone" originProperty="filterTelephone" container={this.props.app}
                    onSubmit={this.props.app.onFilter.bind(this.props.app)}
                    withSaveButton withClearButton
                    />
                </div>
                
                <div className="count">
                    { this.props.loadingCount ? <img src={wait} className="wait_img"/> : <>
                        {( this.props.count>=0 && !this.props.loading ) ? ''+this.props.count+' devis':''}
                        {( this.props.count<0 && !this.props.loading ) ? <a onClick={this.props.loadCount}>Afficher le nombre de devis</a>: ''}
                    </>}
                    <button onClick={this.props.exportCsv}>Export CSV</button>
                </div>
            </div>
        </div>
    }
}

SearchBar.optionsApporteur = [
    { value: 'lesfurets', label: 'Les furets' },
    { value: 'lesfurets3mois', label: 'Les furets Garage 3 mois' },
    { value: 'lelynx', label: 'Le Lynx' },
    { value: 'solly', label: 'Solly Azar'},
    { value: 'assurland', label: 'Assurland'},
    { value: 'assurland-test', label: 'Assurland Test'},
    { value: 'test', label: 'test' },
    { value: 'Website', label: 'Site Web' }
]

SearchBar.optionsStatusProcess = [
    { value: 'ongoing', label: 'En cours' },
    { value: 'subscribed_all', label: 'Toutes soucriptions' },
    { value: 'paid_subscribed', label: 'Souscrit Xena'},
    { value: 'paid_subscribed2', label: 'Souscrit AXA'},
    { value: 'paid_subscribed3', label: 'Souscrit FMA'},
    { value: 'subscribed_solly', label: 'Souscrit sur SollyAzar' },
    { value: 'subscribe_error', label: 'Erreur à la souscription, demande xenassur créée' },
    { value: 'subscribe_error2', label: 'Erreur à la souscription AXA' },
    { value: 'subscribe_error3', label: 'Erreur à la souscription FMA' },
    { value: 'presubscribe_error', label: 'Erreur à la souscription, demande xenassur non créée' },
    { value: 'cancelled', label: 'Annulé' }
]

SearchBar.optionsStatusProcessReal = [
    { value: 'ongoing', label: 'En cours' },
    { value: 'paid_subscribed', label: 'Souscrit Xena'},
    { value: 'paid_subscribed2', label: 'Souscrit AXA'},
    { value: 'paid_subscribed3', label: 'Souscrit FMA'},
    { value: 'subscribed_solly', label: 'Souscrit sur SollyAzar' },
    { value: 'subscribe_error', label: 'Erreur à la souscription, demande xenassur créée' },
    { value: 'subscribe_error2', label: 'Erreur à la souscription AXA' },
    { value: 'subscribe_error3', label: 'Erreur à la souscription FMA' },
    { value: 'presubscribe_error', label: 'Erreur à la souscription, demande xenassur non créée' },
    { value: 'cancelled', label: 'Annulé' }
]


SearchBar.optionsStatusProcessAffiliates = [
    { value: 'ongoing', label: 'En cours' },
    { value: 'paid_subscribed', label: 'Souscrit sur Eco By AssurBonPlan'},
    { value: 'paid_subscribed2', label: 'Souscrit sur Motard Protect'},
    { value: 'paid_subscribed3', label: 'Souscrit sur FMA'},
    { value: 'subscribed_solly', label: 'Souscrit sur AssurBonPlan' }
]

SearchBar.optionsAssureurs = [
    { value: '', label: 'Tous assureurs' },
    { value: 'xenassur', label: 'Xenassur' },
    { value: 'axa', label: 'Axa' },
    { value: 'fma', label: 'FMA' }
]

SearchBar.optionsAssureursOrigin = [
    { value: '', label: 'Toutes origines' },
    { value: 'xenassur', label: 'Origine Xenassur' },
    { value: 'axa', label: 'Origine Axa' },
    { value: 'fma', label: 'FMA' }
]

SearchBar.statusProcessToLabel = (status_process)=>{ 
    const option = SearchBar.optionsStatusProcess.find(option=>{return option.value==status_process})
    return option ? option.label : '??'
}

SearchBar.statusProcessToLabelAffiliate = (status_process)=>{ 
    const option = SearchBar.optionsStatusProcessAffiliates.find(option=>{return option.value==status_process})
    return option ? option.label : '??'
}



SearchBar.optionsStatus = [
    { value: 'Non traité', label:'Non traité'},
    { value: 'Répondeur', label:'Répondeur'},
    { value: 'Répondeur 2', label:'Répondeur 2'},
    { value: 'Répondeur 3', label:'Répondeur 3'},
    { value: 'Répondeur 4', label:'Répondeur 4'},
    { value: 'En cours de traitement', label:'En cours de traitement'},
    { value: 'En attente de retour', label:'En attente de retour'},
    { value: 'Traité', label:'Traité'},
    { value: 'Intéressé à recontacter', label:'Intéressé à recontacter'},
    { value: 'A recontacter', label:'A recontacter'},
    { value: 'Intéréssé nous recontacte', label:'Intéréssé nous recontacte'},
    { value: 'Paiement de l\'accompte validé', label:'Paiement de l\'accompte validé'},
    { value: 'Pas intéressé', label:'Pas intéressé'},
    { value: 'Déjà assuré concurrence', label:'Déjà assuré concurrence'},
    { value: 'Faux numéro / injoignable', label:'Faux numéro / injoignable'},
    { value: 'Devis test', label:'Devis test'},
    { value: 'Doublon', label:'Doublon'},
    { value: 'Hors cible', label:'Hors cible'}
]


export default SearchBar;